export abstract class Participant {

    isLocal: boolean;

    fullName: string;
}
